<div class="page-header">
  <div>
    <h1 class="page-title">Equipment Management</h1>
    <p class="page-subtitle">Manage display equipment, types, and groups</p>
  </div>
  <div class="page-header-actions">
    <button class="btn btn-primary">+ Add Equipment</button>
  </div>
</div>

<nav class="tab-nav">
  <button class="tab-btn" [class.active]="activeTab === 'list'" (click)="activeTab = 'list'">Equipment List</button>
  <button class="tab-btn" [class.active]="activeTab === 'type'" (click)="activeTab = 'type'">Equipment Type</button>
  <button class="tab-btn" [class.active]="activeTab === 'group'" (click)="activeTab = 'group'">Equipment Group</button>
</nav>

<!-- Equipment List -->
<div class="data-card" *ngIf="activeTab === 'list'">
  <div class="data-card-header">
    <div>
      <span class="data-card-title">Equipment List</span>
      <span class="data-count">{{ equipmentList.length }} total</span>
    </div>
    <div class="data-card-meta">
      <input type="text" placeholder="Search equipment..." style="width:220px">
    </div>
  </div>
  <table>
    <thead>
      <tr>
        <th>#</th>
        <th>Name</th>
        <th>Type</th>
        <th>Location</th>
        <th>Serial Number</th>
        <th>Status</th>
        <th>Actions</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let row of equipmentList">
        <td>{{ row.id }}</td>
        <td>{{ row.name }}</td>
        <td>{{ row.type }}</td>
        <td>{{ row.location }}</td>
        <td>{{ row.serial }}</td>
        <td><span class="status-badge status-badge--{{ row.status }}">{{ row.status }}</span></td>
        <td>
          <div class="action-btns">
            <button class="btn-icon" title="Edit">
              <svg width="15" height="15" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>
            </button>
            <button class="btn-icon btn-icon--danger" title="Delete">
              <svg width="15" height="15" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/><path d="M10 11v6"/><path d="M14 11v6"/><path d="M9 6V4h6v2"/></svg>
            </button>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</div>

<!-- Equipment Type -->
<div class="data-card" *ngIf="activeTab === 'type'">
  <div class="data-card-header">
    <div>
      <span class="data-card-title">Equipment Types</span>
      <span class="data-count">{{ equipmentTypes.length }} total</span>
    </div>
    <div class="data-card-meta">
      <input type="text" placeholder="Search types..." style="width:220px">
    </div>
  </div>
  <table>
    <thead>
      <tr>
        <th>#</th>
        <th>Type Name</th>
        <th>Description</th>
        <th>Equipment Count</th>
        <th>Status</th>
        <th>Actions</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let row of equipmentTypes">
        <td>{{ row.id }}</td>
        <td>{{ row.name }}</td>
        <td>{{ row.description }}</td>
        <td>{{ row.count }}</td>
        <td><span class="status-badge status-badge--{{ row.status }}">{{ row.status }}</span></td>
        <td>
          <div class="action-btns">
            <button class="btn-icon" title="Edit">
              <svg width="15" height="15" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>
            </button>
            <button class="btn-icon btn-icon--danger" title="Delete">
              <svg width="15" height="15" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/><path d="M10 11v6"/><path d="M14 11v6"/><path d="M9 6V4h6v2"/></svg>
            </button>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</div>

<!-- Equipment Group -->
<div class="data-card" *ngIf="activeTab === 'group'">
  <div class="data-card-header">
    <div>
      <span class="data-card-title">Equipment Groups</span>
      <span class="data-count">{{ equipmentGroups.length }} total</span>
    </div>
    <div class="data-card-meta">
      <input type="text" placeholder="Search groups..." style="width:220px">
    </div>
  </div>
  <table>
    <thead>
      <tr>
        <th>#</th>
        <th>Group Name</th>
        <th>Equipment Count</th>
        <th>Location</th>
        <th>Status</th>
        <th>Actions</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let row of equipmentGroups">
        <td>{{ row.id }}</td>
        <td>{{ row.name }}</td>
        <td>{{ row.count }}</td>
        <td>{{ row.location }}</td>
        <td><span class="status-badge status-badge--{{ row.status }}">{{ row.status }}</span></td>
        <td>
          <div class="action-btns">
            <button class="btn-icon" title="Edit">
              <svg width="15" height="15" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>
            </button>
            <button class="btn-icon btn-icon--danger" title="Delete">
              <svg width="15" height="15" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/><path d="M10 11v6"/><path d="M14 11v6"/><path d="M9 6V4h6v2"/></svg>
            </button>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</div>
